export default __webpack_public_path__ + "static/media/ContactUsEmail.aed11168.svg";